// extracted by mini-css-extract-plugin
module.exports = {"footer__form":"ProfileChangePassword_footer__form__2slgC","btn__save":"ProfileChangePassword_btn__save__1mI11"};